<template>

        <kt-panel-body >
        <kt-panel>
            <div style="margin-top: 20px;margin-bottom: 50px" class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse"
                     data-target="#filterForm"
                     aria-controls="filterForm">
                    {{$t('settlement.manual_settlement_paya_wage_title')}}
                </div>
            </div>

                <form style="padding-left: 50px;padding-right: 20px" @submit.prevent="update" id="settings_form">
                    <kt-panel-body id="address_repeater">
                        <kt-form-section data-repeater-list="addresses">
                            <kt-row data-repeater-item :style="{display: 'show'}">
                                <kt-form-group class="col-12 col-sm-4 col-md-3">
                                    <kt-form-label for="max">
                                        {{ $t('settlement.manual_settlement_paya_wage_max_amount') }}
                                    </kt-form-label>
                                    <kt-form-control :style="{direction: 'rtl'}"
                                                     dir="ltr"
                                                     data-id="0"
                                                     name="max_amount"
                                                     v-model="banking_result_data.max_amount"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                                <kt-form-group class="col-12 col-sm-8 col-md-3">
                                    <kt-form-label for="percent">
                                        {{ $t('settlement.manual_settlement_paya_wage_percent') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            data-id="0"
                                            name="percent"
                                            v-model="banking_result_data.percent"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-row>
                        </kt-form-section>
                        <kt-form-action class="row mt-4">
                            <kt-button
                                    class="m-2"
                                    size="md"
                                    variant="success"
                                    type="submit"
                                    v-bind:wide="true"
                                    id="submit_btn"
                            >
                                {{ $t('notification.btn.submit') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-panel-body>
                </form>

        </kt-panel>
        </kt-panel-body>

</template>
<script>
    import $ from "jquery";
    import {KTApp} from '@/plugins/core/app'
    import {settlementService} from "@/common/api.service";
    import {mapGetters} from "vuex";

    export default {
        name: "ChangeBankingWage",
        components: {
        },
        props: {
            submit: {
                default: () => {
                },
                type: Function
            },
        },
        data() {
            return {
                data: null,
                res: '',
                paya_wage: {
                    max_amount: "as",
                    percent: 'sdsd'
                },
            }
        },
        computed: {
            ...mapGetters('bankingWage', [
                'form_data', 'status', 'banking_result_data'
            ]),
        },
        mounted() {
            this.$store.dispatch('bankingWage/find')
        },
        methods: {
            update(e) {
                let form = $(e.target)
                let btn = $('#submit_btn')
                let params={
                    max_amount: this.banking_result_data.max_amount,
                    percent: this.banking_result_data.percent,
                }
                KTApp.progress(btn)
                settlementService.changeBankingWage(params).then(response => {
                    this.showMsg(form, 'success', response.data.message)
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                })
                    .finally(() => {
                            KTApp.unprogress(btn)
                        }
                    )
            },
        }
    }


</script>
<style scoped>
</style>